const SELECTOR = '.widget-card, .feature-card, .stats-bar__inner, .method-card'

function init() {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return

  document.querySelectorAll<HTMLElement>(SELECTOR).forEach(bindCard)
}

function bindCard(card: HTMLElement) {
  card.addEventListener('pointerenter', onEnter)
  card.addEventListener('pointermove', onMove)
  card.addEventListener('pointerleave', onLeave)
}

function onEnter(event: PointerEvent) {
  const card = event.currentTarget as HTMLElement
  card.classList.add('is-spotlight')
  onMove(event)
}

function onMove(event: PointerEvent) {
  const card = event.currentTarget as HTMLElement
  const rect = card.getBoundingClientRect()

  card.style.setProperty('--pointer-x', `${event.clientX - rect.left}px`)
  card.style.setProperty('--pointer-y', `${event.clientY - rect.top}px`)
}

function onLeave(event: PointerEvent) {
  const card = event.currentTarget as HTMLElement
  card.classList.remove('is-spotlight')
}

export default { init }
